import * as React from "react"

function SvgAlignHorizCenter(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path stroke="currentColor" d="M23.5 24V8" />
      <path fill="currentColor" stroke="currentColor" d="M19.5 19.5h-11v-2h11zM19.5 14.5h-7v-2h7z" />
    </svg>
  )
}

export default SvgAlignHorizCenter
